import React from 'react';

const BookBanner = ({banner})=>{
    if( null===banner )return <div></div>;
    return (
        <>
            <img src={`${banner.imagePc}`} alt="출판사 배너 이미지" className="_pc" />
            <img src={`${banner.imageMobile}`} alt="출판사 배너 이미지" className="_m" />
        </>
    );
}//end BookBanner
export default BookBanner;